import api from '@/API';
import { QueryResult, UserNotificationFilter } from '@/type';

export default {
  findAll(userId: number, filters: UserNotificationFilter): Promise<QueryResult> {
    return api
      .get(`users/${userId}/notifications`, { params: filters })
      .then(response => response.data);
  },
  findAllUnread(userId: number): Promise<QueryResult> {
    return this.findAll(userId, { isRead: false });
  },
};
